import axios from "axios";
import moment from "moment";
import { GET_PROVIDERS, GET_ALL_PROVIDERS, GET_ALL_VACCINES, GET_ALL_POPULATION_TYPES,
    ProviderDto, ProviderSearchParamsDto, PagedList, VaccineDto, PopulationTypeDto, ProviderAuxiliaryDataDto } from "../models";


const BASE_URL = process.env.REACT_APP_BASE_URL;

export default class API {

    private static urlEncodeParams(data: any): string {
        let keys = Object.keys(data);
        let params = "";
        let keyCount = keys.length - 1;
        keys.forEach((key, idx) => {

            if(Array.isArray(data[key])) {
                let arrData = data[key];
                let p = "";
                for(let i=0; i < arrData.length; i++) {
                    p += idx == 0? `${key}=${arrData[i]}` : `&${key}=${arrData[i]}`
                }
                params += p;
            }
            else {
                if(data[key] == null || data[key] == undefined) {
                    params += idx == 0? `${key}=` : `&${key}=`;
                }
                else if(data[key] instanceof Date) {
                    params += idx == 0? `${key}=${moment(data[key]).format()}` : `&${key}=${moment(data[key]).format()}`;
                }
                else {
                    params += idx == 0? `${key}=${data[key]}` : `&${key}=${data[key]}`;
                }
            }
        })
        
        // console.log(params);
        return params;
    }

    public static async GetProviders(params: ProviderSearchParamsDto): Promise<PagedList<ProviderDto>> {
        return new Promise(async (resolve, reject) => {
            try {
                // const data = {
                //     name: "",
                //     municipalityId: null,
                //     vaccineId: null,
                //     populationTypeId: null,
                //     startTime: null,
                //     endTime: null,
                //     pageNumber: 0,
                //     pageSize: 5
                // }
    
                const result = await axios.get(`${BASE_URL}/${GET_PROVIDERS}?${this.urlEncodeParams(params)}`);
                // console.log(result.data.data);
                resolve(result.data.data as PagedList<ProviderDto>);
    
            } catch (error) {
                console.log(error);
                reject(error);
            }
        })
    }

    public static async GetProviderAuxiliaryData(providerId: string): Promise<ProviderAuxiliaryDataDto> {
        return new Promise(async (resolve, reject) => {
            try {
                
                const result = await axios.get(`${BASE_URL}/${GET_PROVIDERS}/${providerId}`);
                resolve(result.data.data as ProviderAuxiliaryDataDto);

            } catch (error) {
                reject(error);
            }
        })
    }

    public static async GetAllProviders(): Promise<PagedList<ProviderDto>> {
        return new Promise(async (resolve, reject) => {
            try {

                const result = await axios.get(`${BASE_URL}/${GET_ALL_PROVIDERS}`);
                resolve(result.data.data as PagedList<ProviderDto>);
    
            } catch (error) {
                console.log(error);
                reject(error);
            }
        })
    }

    public static async GetAllVaccines(): Promise<VaccineDto[]> {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await axios.get(`${BASE_URL}/${GET_ALL_VACCINES}`);
                resolve(result.data.data as VaccineDto[]);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        })
    }

    public static async GetAllPopulationTypes(): Promise<PopulationTypeDto[]> {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await axios.get(`${BASE_URL}/${GET_ALL_POPULATION_TYPES}`);
                resolve(result.data.data as PopulationTypeDto[]);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        })
    }


}